package com.appcreator.compose.actions

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.actions.ReviewPromptAction
import com.appcreator.blueprint.core.EnvStore
import com.russhwolf.settings.Settings
import kotlin.time.Clock
import kotlin.time.Instant

class ReviewPromptPerformer(private val action: ReviewPromptAction): Performer {
    companion object {
        const val showAfterCounter = "ReviewPromptPerformer.showAfter"
        const val timestampeKey = "ReviewPromptPerformer.timestamp"
    }

    private val settings = Settings()

    @Composable
    override fun deferred(): Performer.Deferred {
        val deferred = ReviewPromptPerformerDeferred(action)
        return object : Performer.Deferred {
            override suspend fun perform(envStore: EnvStore) {

                val attemptCount = settings.getInt(showAfterCounter, 0) + 1
                settings.putInt(showAfterCounter, attemptCount)

                if(attemptCount < (action.showOnAttempt?: 1)) {
                    println("Skipping review prompt, not enough attempts")
                    return
                }

                val now = Clock.System.now()
                val lastRequest = settings.getStringOrNull(timestampeKey)
                lastRequest?.let {
                    val lastReview = Instant.parse(lastRequest)
                    val duration = now.minus(lastReview)
                    if(duration.inWholeDays > (action.attemptFrequency?: 30)) {
                        deferred.perform(envStore)
                        settings.putString(timestampeKey, now.toString())
                    } else {
                        println("Skipping review prompt, not enough time passes since last shown")
                    }
                }?: run {
                    deferred.perform(envStore)
                    settings.putString(timestampeKey, now.toString())
                }
            }
        }
    }
}

@Composable
expect fun ReviewPromptPerformerDeferred(action: ReviewPromptAction): Performer.Deferred